import React, {Component} from "react";
import {Badge, Icon} from "antd";

export class ClearAllButton extends Component {
  render() {
    return <div
      onClick={() => this.props.handleClearItems()}
      style={{
        position: 'absolute',
        left: 478,
        top: 27,
        cursor: 'pointer'
      }}
    >
      <Badge style={{float: "left", clear: "both", position: "absolute", left: 3, zIndex: 999}}
             count={<Icon type='close-circle' theme='twoTone' twoToneColor='#d41414'/>}>
      </Badge>
      <Badge
        count={"\u00A0\u00A0\u00A0\u00A0Clear All"}
        style={{
          backgroundColor: "#fff",
          color: "#d41414",
          boxShadow: "0 0 0 1px #000 inset"
        }}
      />
    </div>;
  }
}